const IntroductionData = [
  "I am a",
  "Full Stack Software Engineer",
  "I am a Full Stack Software Engineer with 2 years of experience in crafting intelligent, scalable software solutions that drive business innovation. I hold a Master's degree in Software Engineering and Intelligent Systems from the University of Alberta (2024) and am certified in leading cloud technologies, including AWS and Microsoft Azure."]

export default IntroductionData;
